import types from '../../../mutation-types';
import { hasConditions } from 'dashboard/helper/conditionGroups';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const isOnParticipatingView = ({ route: { name: routeName } }) => {
  const PARTICIPATING_ROUTES = [
    'conversation_participating',
    'conversation_through_participating',
  ];
  return PARTICIPATING_ROUTES.includes(routeName);
};

// A tela aberta mostra um conjunto que os getters NAO sabem reproduzir?
//
// `applyPageFilters` -- o recorte que os getters aplicam em cima de
// `allConversations` -- sabe filtrar status, inbox, time, label e
// nao-atendidas. Isso e o bastante para segurar o que entrar ali por evento
// de socket: se a conversa nao casa com o recorte, ela nao renderiza.
//
// Pastas, filtros salvos, mencoes e participando sao o caso oposto: o
// conjunto vem do servidor (`filterResultIds`) ou de um evento proprio
// (`conversation.mentioned`), e nao ha nada em `applyPageFilters` que o
// reproduza. Nessas telas, o que for empurrado para `allConversations`
// aparece na lista sem passar por filtro nenhum -- e some no F5, porque o
// servidor nunca devolveria aquilo.
//
// Nao-atendidas fica DE FORA de proposito: `filterByUnattended` ja recorta a
// aba, entao inserir ali e legitimo -- a conversa aparece exatamente quando
// passa a ser nao atendida, que e o que o servidor tambem devolveria.
export const isOnFilteredConversationView = (state, rootState) =>
  hasConditions(state.appliedFilters) ||
  isOnFoldersView(rootState) ||
  isOnMentionsView(rootState) ||
  isOnParticipatingView(rootState);

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  context.commit(types.SET_ALL_CONVERSATION, conversationList);
  if (filterType === 'appliedFilters') {
    context.commit(
      types.SET_FILTER_RESULT_IDS,
      conversationList.map(c => c.id)
    );
  }
  context.dispatch('conversationStats/set', {
    meta: metaData,
    params: requestPayload,
  });
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  // Lista construida com sucesso: nao ha falha pendente que descrever.
  //
  // A guarda de sequencia impede uma resposta atrasada de marcar falha, mas nao
  // cobre a falha que foi legitima e depois deixou de valer -- o refetch do
  // ReconnectService, por exemplo, roda sem gesto do usuario, e so
  // `SET_LIST_LOADING_STATUS` zerava a marca. Sem isto a lista voltava correta
  // e mesmo assim exibia "nao foi possivel carregar" no rodape.
  context.commit(types.SET_LIST_FETCH_FAILED, false);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: conversationList.length < 25,
  });
};
